import i18next from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import HttpApi from "i18next-http-backend";
import { initReactI18next } from "react-i18next";

import svTranslation from "../locales/sv/translation.json";
import enTranslation from "../locales/en/translation.json";
import deTranslation from "../locales/de/translation.json";

export const supportedLngs: { [key: string]: { name: string; locale: string } } = {
    sv: {
        name: "Svenska",
        locale: "sv-SE"
    },
    en: {
        name: "English",
        locale: "en-US"
    },
    de: {
        name: "Deutsch",
        locale: "de-DE"
    }
};

i18next
    .use(HttpApi)
    .use(LanguageDetector)
    .use(initReactI18next)
    // init i18next
    // for all options read: https://www.i18next.com/overview/configuration-options
    .init({
        resources: {
            sv: { translation: svTranslation },
            en: { translation: enTranslation },
            de: { translation: deTranslation }
        },
        fallbackLng: "sv",
        supportedLngs: Object.keys(supportedLngs),
        debug: import.meta.env.DEV,
        interpolation: {
            escapeValue: false // not needed for react as it escapes by default
        },
        detection: {
            order: ["localStorage", "navigator"],
            lookupLocalStorage: "i18nextLng",
            caches: ["localStorage"]
        }
    });

export default i18next;
